import { render, staticRenderFns } from "./PowerWay.vue?vue&type=template&id=e8ac8b1c&scoped=true"
import script from "./PowerWay.vue?vue&type=script&lang=js"
export * from "./PowerWay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8ac8b1c",
  null
  
)

export default component.exports